module.exports = "pegasus/assets/styleGroup3-facebook.png";